// ----------------------------------------------------------------------------
// Section: Site Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/announcement-bar/announcement-bar';
import 'snippets/menu/menu';
import 'snippets/header-menu/header-menu';
import 'snippets/country-switcher/country-switcher';
import 'snippets/account-menu/account-menu';
import 'snippets/cart-dropdown/cart-dropdown'; // TODO: include mini cart here for now.
import 'snippets/search-form/search';
import 'snippets/predictive-search/predictive-search';
import 'snippets/icon/icon';

// Styles
import './_header.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
var HEADER_SELECTOR = '.header';
var HAMBURGER_SELECTOR = '.header__link--menu';
var MENU_WRAPPER_SELECTOR = '.header__nav-wrapper';
var MENU_ITEM_SELECTOR = '.header-menu__item--dropdown';
var MENU_BUTTON_SELECTOR = '.header-menu__button';

// Classes
var OPEN_CLASS = 'js--is-open';
var NO_SCROLL_CLASS = 'noscroll';

// -------------------------------------
// Helper functions
// -------------------------------------

// Open the menu
function openMenu(menu) {
  menu.$body.classList.add(NO_SCROLL_CLASS);
  menu.$header.classList.add(OPEN_CLASS);
  menu.$hamburger.classList.add(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'true');
  var $section = menu.$header.closest('.section--header');
  if ($section) $section.classList.add(OPEN_CLASS);
}

// Close the menu
function closeMenu(menu) {
  menu.$body.classList.remove(NO_SCROLL_CLASS);
  menu.$header.classList.remove(OPEN_CLASS);
  menu.$hamburger.classList.remove(OPEN_CLASS);
  var $section = menu.$header.closest('.section--header');
  if ($section) $section.classList.remove(OPEN_CLASS);
  menu.$hamburger.setAttribute('aria-expanded', 'false');
  removeClassFromElements(menu.$items, OPEN_CLASS);
  setAttributeForElements(menu.$buttons, 'aria-expanded', 'false');
}

// Remove a given class from a list of elements
function removeClassFromElements(elems, className) {
  elems.forEach(function (elem) {
    elem.classList.remove(className);
  });
}

// Set the value of a given attribute for a list of elements
function setAttributeForElements(elems, attribute, value) {
  elems.forEach(function (elem) {
    elem.setAttribute(attribute, value);
  });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function () {
  var menu = {
    $body: document.querySelector('body'),
    $header: document.querySelector(HEADER_SELECTOR),
    $hamburger: document.querySelector(HAMBURGER_SELECTOR),
    $items: document.querySelectorAll(MENU_ITEM_SELECTOR),
    $buttons: document.querySelectorAll(MENU_BUTTON_SELECTOR)
  };
  if (!menu.$hamburger) return;

  // Toggle the mobile menu when the hamburger is clicked or pressed with keyboard
  menu.$hamburger.addEventListener('click', function (event) {
    event.preventDefault();
    if (menu.$hamburger.classList.contains(OPEN_CLASS)) {
      closeMenu(menu);
    } else {
      openMenu(menu);
      // Focus first menu item when opening
      var mobileLinks = document.querySelectorAll('.header-menu__list--mobile .header-menu__link');
      var firstLink = null;
      Array.prototype.some.call(mobileLinks, link => {
        if (link.offsetParent !== null) {
          firstLink = link;
          return true;
        }
        return false;
      });
      if (firstLink) {
        firstLink.focus();
      }
    }
  });
  menu.$hamburger.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      menu.$hamburger.click();
    }
  });

  // Close menu when clicking outside of it
  menu.$body.addEventListener('click', function (event) {
    var $this = event.target;

    // Don't close if clicking hamburger (handled above) or inside menu
    if ($this.closest(HAMBURGER_SELECTOR) === null && $this.closest(MENU_WRAPPER_SELECTOR) === null) {
      if (menu.$header.classList.contains(OPEN_CLASS)) {
        closeMenu(menu);
      }
    }
  });

  // Close menu on Escape key
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && menu.$header.classList.contains(OPEN_CLASS)) {
      closeMenu(menu);
      menu.$hamburger.focus();
    }
  });
});

// -------------------------------------
// Sticky Header - Hide on scroll down, show on scroll up
// -------------------------------------

var lastScrollTop = 0;
var ticking = false;
var HEADER_WRAPPER_SELECTOR = '.header-wrapper';
var HIDDEN_CLASS = 'header-wrapper--hidden';
var PRODUCT_SECTION = '#shopify-section-product';
function updateStickyHeader() {
  var productSection = document.querySelector(PRODUCT_SECTION);

  // Don't hide header on product pages
  if (productSection !== null) {
    ticking = false;
    return;
  }
  var headerWrapper = document.querySelector(HEADER_WRAPPER_SELECTOR);
  if (!headerWrapper) {
    ticking = false;
    return;
  }
  var noScrollBody = document.querySelector('body.noscroll');
  var megamenuOpen = document.querySelector('.header-menu__item--dropdown.js--is-open');
  var st = document.documentElement.scrollTop || window.pageYOffset;

  // If mobile menu or megamenu is open, always show header
  if (noScrollBody || megamenuOpen) {
    headerWrapper.classList.remove(HIDDEN_CLASS);
    ticking = false;
    return;
  }

  // Hide header when scrolling down, show when scrolling up
  if (st > lastScrollTop && st > 100) {
    // Scrolling down and past 100px - hide header
    headerWrapper.classList.add(HIDDEN_CLASS);
  } else if (st < lastScrollTop) {
    // Scrolling up - show header
    headerWrapper.classList.remove(HIDDEN_CLASS);
  } else if (st <= 100) {
    // At top of page - always show
    headerWrapper.classList.remove(HIDDEN_CLASS);
  }
  lastScrollTop = st <= 0 ? 0 : st;
  ticking = false;
}
function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(updateStickyHeader);
    ticking = true;
  }
}
window.addEventListener('scroll', onScroll, {
  passive: true
});